import {
    Box,
    Table,
    Tbody,
    Td,
    Text,
    Th,
    Thead,
    Tr,
    useDisclosure,
    useToast
} from "@chakra-ui/react";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link, useHistory, useParams } from "react-router-dom";
import { AccountAvatar } from "../../components/AccountAvatar";
import { Loader } from "../../components/Loader";
import { Title } from "../../components/Title";
import { useGetHostedEventsQuery } from "../../graphql";
import { formatDateTime } from "../../utils";

const MyEventsPage: React.FC = () => {
    const { t } = useTranslation();
    const { data, loading } = useGetHostedEventsQuery();

    return (
        <>
            <Box
                borderWidth="1px"
                borderRadius="lg"
                overflow="hidden"
                p={ 2 }
                background="white"
            >
                { loading ? (
                    <Loader />
                ) : (
                    <>
                        <Title title={ t("events.title") }></Title>

                        <Table variant="striped">
                            <Thead>
                                <Tr>
                                    <Th>{ t("events.organiser") }</Th>
                                    <Th>{ t("events.eventTitle") }</Th>
                                    <Th isNumeric>{ t("events.participants") }</Th>
                                    <Th isNumeric>{ t("events.date") }</Th>
                                    <Th isNumeric>{ t("events.duration") }</Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                                { data.getEvents.map((event) => (
                                    <Tr key={ event.id }>
                                        <Td>
                                            <Link to={ `/event/${event.id}` }>
                                                <AccountAvatar
                                                    account={ event.specialist }
                                                    role={ false }
                                                    size="sm"
                                                />
                                            </Link>
                                        </Td>
                                        <Td>{ event.title }</Td>
                                        <Td isNumeric>
                                            { event.participants.list.length } /
                                            { event.participants.maxNumber }
                                        </Td>
                                        <Td isNumeric>{ formatDateTime(event.startDate) }</Td>
                                        <Td isNumeric>
                                            { event.durationMinutes } { t("events.minutes") }
                                        </Td>
                                    </Tr>
                                )) }
                            </Tbody>
                        </Table>
                    </>
                ) }
            </Box>
        </>
    );
};

export default MyEventsPage;
